import { Buffer } from 'buffer';

// З байтів в мегабайти
export const getFileSizeMB = ({ size }) => {
    try {
        let sizeFull = ''

        if (size) { // Розмір в байтах
            sizeFull = size / 1000000
            if (sizeFull) {
                sizeFull = sizeFull.toFixed(2)
                sizeFull += ' МБ'
            }
        }

        return sizeFull
    } catch (e) {}
}

// Перевірити, щоб всі файли мали вірний формат
export const isFilesHaveFormat = ({ type, files }) => { 
    try {
        let isOk = true

        if (files && files.length > 0 && type) { // Розмір в байтах
            for (const file of files) {
                if (!file.type.includes(type + '/')) {
                    isOk = false
                }
            }
        } else if (type) {
            isOk = false
        }

        return isOk
    } catch (e) {}
}


export const downloadFile = ({ result, setResult, setOpen }) => {
    try {
        // const buffer = Buffer.from(result);
        const buffer = Buffer.from(result.file);
        const blob = new Blob([buffer]);

        // const name = type && type === 'barcode' ? "штрих-коди на всю партію.zip" : "qr-коди на всю партію.zip"
        const name = result.fileName
                                   
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);

        setResult('')

        if (setOpen) {
            setOpen(false)
        }
    } catch (e) {
        
    }
}